import {
  takeLatest, put,
} from 'redux-saga/effects';
import { select } from 'app/store/utils/saga/effects';

import * as lastPageActions from '../actions';

export const config = {
  action: lastPageActions.shiftStep.type,
  method: takeLatest,
};

export function* func(action: lastPageActions.ILastPageShiftStepPayload) {
  const { payload } = action;
  const value = payload?.value || 0;
  const step = yield* select((state) => state.lastPage.currentStep);
  const length = yield* select((state) => {
    const lastPage = state.card.pages.find((item: any) => item.type === 'PageEnd') || null;
    return lastPage?.itemsOrder?.length || 0;
  });

  const nextStep = step + value;

  yield put(lastPageActions.setStep(nextStep >= length ? step : nextStep));
}
